// extracted by mini-css-extract-plugin
export default {"abby":"taboola-ultimate-ui_chat-agent_theme_abby__-YEaJ"};